import BillingItem from './billing_item'

export default class BillingItemWithReceipts extends BillingItem {
  constructor(element) {
    super(element)
    this.fileInput = element.querySelector('.bill_billing_items_receipts input[type=file]')
    this.fileLabel = element.querySelector('.bill_billing_items_receipts [file-input--filename]')

    this.userInputFields.push(this.fileLabel)
  }

  isValid() {
    let valid = super.isValid()
    if (!this.isDestroyed()) {
      const attachedFiles = Array.from(this.element.querySelectorAll(`.bill_billing_items_receipts input[type='hidden'][name="${this.fileInput.name}"]:not(:disabled)`))
        .filter(hiddenInput => hiddenInput.value)
      if (attachedFiles.length === 0) {
        this.markAsInvalid(this.fileLabel)
        valid = false
      }
    }
    return valid
  }
}
